import { colors } from '@globals/themes/defaultTheme'
import { semiBoldFontWeight } from '@globals/themes/themeConstants'
import { MediaObjectUrl } from '@kudos/http-client'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { SxProps } from '@mui/material/styles'
import UserAvatar from '@shared/avatar/UserAvatar'
import UserNameDisplay from '@shared/userDisplay/UserNameDisplay'
import { nameOverflowStyle } from '@shared/userDisplay/nameOverflowStyle'
import { T } from '@transifex/react'

const bannerStyle: SxProps = {
  backgroundColor: colors.greenExtraLight,
  px: 2,
  py: 1,
}

type DelegationBannerProps = {
  delegatorId?: string | null
  delegatorFirstName?: string
  delegatorLastName?: string
  delegatorAvatarUrls?: MediaObjectUrl | null
  hasBorderRadius?: boolean
}

const DelegationBanner: React.FC<DelegationBannerProps> = ({
  delegatorId,
  delegatorFirstName,
  delegatorLastName,
  delegatorAvatarUrls,
  hasBorderRadius = false,
}) => {
  const delegator = { id: delegatorId, firstName: delegatorFirstName, lastName: delegatorLastName }

  return (
    <Box sx={{ ...bannerStyle, borderRadius: hasBorderRadius ? '8px' : '0px' }}>
      <Stack
        direction="row"
        spacing={1}
        sx={{
          alignItems: 'center',
          minWidth: 0,
        }}>
        <UserAvatar
          tenantMemberId={delegatorId}
          firstName={delegatorFirstName}
          lastName={delegatorLastName}
          media={delegatorAvatarUrls}
          size={36}
        />
        <Typography
          variant="body1"
          sx={{ color: colors.greenDark, minWidth: 0, flex: 1, ...nameOverflowStyle }}>
          <T
            _str="You're sending on behalf of {name}"
            name={
              <UserNameDisplay
                user={delegator}
                sx={{ ...nameOverflowStyle, fontWeight: semiBoldFontWeight }}
              />
            }
          />
        </Typography>
      </Stack>
    </Box>
  )
}

export default DelegationBanner
